import styled from 'styled-components';

export const Positioner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  height: 50px;
`;

export const Shadows = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 999px;
  pointer-events: none;
`;

export const PillScrollContainer = styled.nav`
  width: 100%;
  height: 100%;
  border-radius: 999px;
  overflow-x: scroll;
  display: flex;
  align-items: center;
  background: #fff;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const ElementsContainer = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #fff;
`;

export const Gradients = styled.div`
  position: absolute;
  border-radius: 999px;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 10%,
    rgba(255, 255, 255, 0) 90%,
    rgba(255, 255, 255, 1) 100%
  );
  pointer-events: none;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
  max-width: 100%;
`;
